import React from 'react';

import { Text } from '@change/ds-core-ui';
import { Radio, RadioGroup } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

type TrackingContext = 'status_filter_trending' | 'status_filter_all' | 'status_filter_victories';

type StatusFilterProps = {
	setAllPetitions: () => void;
	setVictoriesOnly: () => void;
	setTrending: () => void;
	isAllPetitionsChecked: boolean;
	isVictoriesOnlyChecked: boolean;
	isTrendingChecked: boolean;
	disabled: boolean;
	trackStatusFilterClick: (context: TrackingContext) => void;
};

export const DesktopStatusFilter: React.FC<StatusFilterProps> = ({
	setAllPetitions,
	setVictoriesOnly,
	setTrending,
	isAllPetitionsChecked,
	isVictoriesOnlyChecked,
	isTrendingChecked,
	disabled,
	trackStatusFilterClick,
}) => {
	const { translate } = useI18n();
	const getValue = () => {
		if (isAllPetitionsChecked) return 'all_petitions';
		if (isVictoriesOnlyChecked) return 'victories_only';
		if (isTrendingChecked) return 'trending';
		return 'all_petitions';
	};
	const value = getValue();
	return (
		<div>
			<Text as="h2" variant="heading" size="x-small" fontWeight="normal" className="mb-4">
				<Translate value="corgi.search.filters.status.title" />
			</Text>
			<div className="flex flex-col flex-wrap gap-4">
				<RadioGroup
					data-qa="status-filter-radio-group"
					data-testid="status-filter-radio-group"
					isDisabled={disabled}
					label={translate('corgi.search.filters.status.title')}
					labelIsVisible={false}
					name="status-filter"
					value={value}
					onChange={(newValue) => {
						switch (newValue) {
							case 'all_petitions':
								setAllPetitions();
								trackStatusFilterClick('status_filter_all');
								break;
							case 'victories_only':
								setVictoriesOnly();
								trackStatusFilterClick('status_filter_victories');
								break;
							case 'trending':
								setTrending();
								trackStatusFilterClick('status_filter_trending');
								break;
							default:
								break;
						}
					}}
				>
					<Radio data-testid="all_petitions_radio" data-qa="status-filter-checkbox" value="all_petitions">
						<Translate value="corgi.search.filters.status.options.all" />
					</Radio>
					<Radio data-testid="victories_only_radio" data-qa="status-filter-checkbox" value="victories_only">
						<Translate value="corgi.search.filters.status.options.victories_only" />
					</Radio>
					<Radio data-testid="trending_radio" data-qa="status-filter-checkbox" value="trending">
						<Translate value="corgi.search.filters.status.options.trending" />
					</Radio>
				</RadioGroup>
			</div>
		</div>
	);
};
